import {createApp} from 'vue/dist/vue.esm-bundler'

import {VueMasonryPlugin} from "vue-masonry";


// ensure the main object is defined
if (typeof (so) === 'undefined') {
    var so = {};
}

so.project_listing = createApp({
    config: {
        devtools: false
    },
    data: function () {
        return {
            category_options: [],
            sector_options: [],
            filters: {
                name: '',
                sector: [],
                category: []
            },
            projects: [],
            notLoaded: true,
            page: 0,
            postsPerPage: 8,
            extend: 1,
            showMoreAvailable: false,
            fullListing: true,
            numberFilteredProjects: 0
        }
    },
    computed: {
        filtersActive: function () {
            return (
                this.filters.category.length > 0 ||
                this.filters.sector.length > 0 ||
                this.filters.name.length > 0
            );
        },
        filteredProjects: function () {
            let page = this.page;
            return this.filterProjects();
        },
        postsPerPageWithOverflow: function () {
            if (this.showMoreAvailable) {
                let target = this.postsPerPage * this.extend;
                let overflow = this.numberFilteredProjects - target;
                return (overflow < this.postsPerPage) ? overflow : this.postsPerPage;
            }
        }
    },
    watch: {
        filters: {
            deep: true,
            handler: function () {
                this.page++;
                this.filteredProjects;
            }
        }
    },
    mounted: function () {
        this.init();
    },
    methods: {
        init: function () {
            this.install();
        },
        install: function (projects, categories, sectors, postsPerPage, fullListing) {

            if (projects) {
                this.projects = projects;
                this.numberFilteredProjects = this.projects.length;
            }
            if (categories) {
                this.category_options = categories;
            }
            if (sectors) {
                this.sector_options = sectors;
            }

            if (postsPerPage) {
                this.postsPerPage = postsPerPage;
            }
            if (fullListing) {
                this.fullListing = fullListing;
            }

            this.notLoaded = false;

            // this.status_options.sort((a, b) => (a < b) - (a > b));
            // this.sector_options.sort((a, b) => (a > b) - (a < b));

        },
        redirect: function (link) {
            if (link) {
                window.location.href = link;
            }
        },
        removeFilterSector: function (sector) {
            var index = this.filters.sector.indexOf(sector);
            this.filters.sector.splice(index, 1);
        },
        removeFilterCategory: function (category) {
            var index = this.filters.category.indexOf(category);
            this.filters.category.splice(index, 1);
        },
        removeFilterName: function () {
            this.filters.name = '';
        },
        clearAllFilters: function () {
            this.filters.category = [];
            this.filters.sector = [];
            this.filters.name = '';
            this.filteredProjects;
        },
        sortProjects: function (projects) {
            return projects.sort(function (a, b) {
                if (a.FeaturedProject === b.FeaturedProject)
                    return b.SortingDate - a.SortingDate;
                else if (a.FeaturedProject)
                    return -1;
                else return 1;
            });


            return projects.sort((a, b) => (a.FeaturedProject === b.FeaturedProject) || (a.SortingDate < b.SortingDate) - (a.SortingDate > b.SortingDate));
        },
        extendListing: function () {
            this.extend = this.extend + 1;
        },
        clipProjects: function (temp_projects) {
            if (!temp_projects || temp_projects.length === 0 || this.filtersActive) {
                this.showMoreAvailable = false;
                this.numberFilteredProjects = 0;
                this.page++;
                this.filteredProjects;

                return temp_projects;
            }
            temp_projects = JSON.parse(JSON.stringify(temp_projects));
            this.numberFilteredProjects = temp_projects.length;
            var clipTo = this.postsPerPage * this.extend;
            if (temp_projects.length > clipTo) {
                temp_projects = temp_projects.splice(0, clipTo);
                this.showMoreAvailable = true;
            } else {
                this.showMoreAvailable = false;
            }
            this.page++;
            this.filteredProjects;

            return temp_projects;
        },
        filterProjects: function () {
            var tProjects = [], nameProjects = [], categoryProjects = [], sectorProjects = [], uniqueIds = [], clipTo;

            if (this.notLoaded) {
                return [];
            }
            if (!this.filtersActive) {
                tProjects = this.projects;
                if (this.projects && this.projects.length > 0) {
                    tProjects = this.sortProjects(tProjects);
                }
                tProjects = this.clipProjects(tProjects);
                return tProjects;
            }

            if (this.filters.name && this.filters.name.length > 0) {
                nameProjects = this.projects.filter(project => project.Title.toLowerCase().includes(this.filters.name.toLowerCase()));

                for (let i = 0; i < nameProjects.length; i++) {
                    tProjects.push(nameProjects[i]);
                }
            }


            if (this.filters.category.length > 0) {
                for (let i = 0; i < this.filters.category.length; i++) {
                    let target = "|" + this.filters.category[i].ID + "|";
                    let tempArray = [];
                    tempArray = this.projects.filter(function (project) {
                        return (project.ProjectCategoryIDs.includes(target));
                    });
                    categoryProjects = categoryProjects.concat(tempArray);
                }

                for (let i = 0; i < categoryProjects.length; i++) {
                    tProjects.push(categoryProjects[i]);
                }


            }

            if (this.filters.sector.length > 0) {
                for (let i = 0; i < this.filters.sector.length; i++) {
                    let target = "|" + this.filters.sector[i].ID + "|";
                    let tempArray = [];
                    tempArray = this.projects.filter(function (project) {
                        return (project.ProjectSectorIDs.includes(target));
                    });
                    sectorProjects = sectorProjects.concat(tempArray);
                }

                for (let i = 0; i < sectorProjects.length; i++) {
                    tProjects.push(sectorProjects[i]);
                }

            }

            uniqueIds = [];
            tProjects = tProjects.filter(function (project) {
                const isDuplicate = uniqueIds.includes(project.ID);

                if (!isDuplicate) {
                    uniqueIds.push(project.ID);
                    return true;
                }

                return false;
            });


            if (tProjects.length > 0) {
                tProjects = this.sortProjects(tProjects);
            }

            tProjects = this.clipProjects(tProjects);

            return tProjects;
        }
    }


}).use(VueMasonryPlugin).mount('#projectslisting_app');


//
//
// // ensure the main object is defined
// if (typeof (so) === 'undefined') {
//     var so = {};
// }
//
// so.project_listing = new Vue({
//     data: {
//         category_options: [],
//         sector_options: [],
//         filters: {
//             name: '',
//             sector: '',
//             status: '',
//             category: ''
//         },
//         projects: [],
//         notLoaded: true,
//         page: 0,
//         postsPerPage: 8
//     },
//     computed: {
//
//     },
//     methods: {
//         init: function () {
//             this.$nextTick(() => {
//                 this.install();
//             })
//         },
//         install: function () {
//             if (window.soimport.filters) {
//                 // so.project_listing.category_options = window.soimport.Projects.Categories;
//                 // so.project_listing.sector_options = window.soimport.Projects.Suburbs;
//             }
//             if (window.soimport.projects) {
//                 so.project_listing.projects = window.soimport.Projects;
//             }
//
//             this.windowSize();
//
//             this.notLoaded = false;
//
//             // this.status_options.sort((a, b) => (a < b) - (a > b));
//             // this.sector_options.sort((a, b) => (a > b) - (a < b));
//
//         }
//     }
// }).$mount('#projectslisting_app');
//

$(window).ready(function () {

    so.project_listing.install(
        soimport.data.Projects,
        soimport.data.Categories,
        soimport.data.Sectors,
        soimport.data.PostsPerPage,
        soimport.data.FullListing
    );


});
